
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/confidentialite",
      function () {
        return require("private-next-pages/confidentialite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/confidentialite"])
      });
    }
  